import type { FilterDefinition } from '@factorialco/f0-react/dist/experimental'
import type { BankAccountSelectorF0Query } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import { formattedBankAccountNumber } from 'modules/banking/utils'

type BankAccountNode = NonNullable<
  BankAccountSelectorF0Query['banking']
>['bankAccountsConnection']['edges'][number]['node']

type InFilterSource = Extract<
  Extract<FilterDefinition, { type: 'in' }>['options'],
  { source: unknown }
>['source']

const isInFilterSource = (source: unknown): source is InFilterSource =>
  typeof source === 'object' && source !== null && 'dataAdapter' in source

export const createAccountFilter = (source: unknown): FilterDefinition => ({
  label: i18n.t('banking.payments.data_table.origin_account'),
  type: 'in',
  options: isInFilterSource(source)
    ? {
        source,
        mapOptions: (account: BankAccountNode) => {
          const formattedNumber = formattedBankAccountNumber(account)
          const label = account.accountAlias
            ? `${account.accountAlias} - **** ${formattedNumber.slice(-4)}`
            : formattedNumber

          return {
            label,
            value: String(account.id),
          }
        },
      }
    : { options: [] },
})
